import script from "./ContentModal.vue?vue&type=script&setup=true&lang=js"
export * from "./ContentModal.vue?vue&type=script&setup=true&lang=js"

import "./ContentModal.vue?vue&type=style&index=0&id=22576f56&lang=css"

const __exports__ = script;

export default __exports__